import React from 'react';

const Home = () => {
    return( 
        <div className="image-container">
            {<img className="individual-image-main" src={'https://lorraineshemeshsiteimgs2.s3.us-east-2.amazonaws.com/rising.jpg'} alt="Rising painting, Lorraine Shemesh"/>}
        </div>
    )
}

export default Home;